<script>
	import { push } from 'svelte-spa-router';
	import { onMount } from 'svelte';


	onMount(() => {
		push(`/Job_Create`);
	});
</script>